module.exports = {
    Lang: {
        de: 'Allemand',
        en: 'Anglais',
        es: 'Espagnol',
        fr: 'Français',
        pt: 'Portugais',
        it: 'Italien',
        ru: 'Russe'
    },
    Action: {
        add: 'Ajouter',
        edit: 'Gérer',
        remove: 'Annuler al commande',
        close: 'Fermer',
        select: 'Sélectionnez',
        save: 'Sauvegarder',
        saving: 'Est sauvé',
        send: 'Envoyer',
        confirmSelection: 'Confirmer la sélection',
        change: 'Modifier',
        changeSelection: 'Modifier la sélection',
        next: 'Continer',
        prev: 'Retour',
        finish: 'Terminé',
        'search': 'Recherche'
    },
    Common: {
        start: 'Démarrer',
        date: 'Date',
        creationdate: 'Date de création',
        lastmodified: 'Dernière modification',
        status: 'Situation',
        color: 'Couleur',
        settings: 'Réglages',
        masterdata: 'Données de base',
        masterdataSaved: 'Les données de base ont été sauvegardées',
        amount: 'Montant',
        description: 'Description',
        item: 'Produit',
        itemNum: 'N° du produit',
        itemName: 'Nom du produit',
        itemPrice: 'Prix du produit',
        quantity: 'Quantité',
        singlePrice: 'Prix de l`unité',
        discount: 'Rabais',
        rebate: 'Rabais',
        vat: 'TVA',
        total: 'Total',
        orderPrice: 'Prix de la commande',
        annotation: 'Note',
        accountDetails: 'Données du client',
        customerNum: 'N° du client',
        salutation: 'Phrase de salutation',
        firstname: 'Prénom',
        lastname: 'Nom de famille',
        company: 'Compagnie',
        email: 'e-mail',
        contact: 'Contact',
        address: 'Adresse',
        postalcode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        taxDetails: 'Données sur les impôts',
        vatId: 'N° de la T.V.A.',
        noEntries: 'Aucune entrée',
        languageSettings: 'Choix de la langue',
        showXtoYentries: 'Montrer {x} jusque {y} résultats',
        showXtoYofZentries: 'Afficher les résultats de {x} à {y} de {z}',
        errorSavingMasterdata: 'Les données de base n`ont pas pu être sauvegardées',
        errorIncomplete: 'Formulaire incomplet',
        errorFieldMissing: '{field} doit être rempli',
        errorUploadInvalidResp: 'Réponse invalide du serveur. Veuillez réessayer ou contacter notre support.',
        noSelection: 'Pas de sélection'
    },
    Units: {
        C62: 'pcs.',
        GRM: 'g'
    },
    Dashboard: {
        title: 'Tableau de bord'
    },
    Addresses: {
        title: 'Adresses',
        add: 'Nouvelle adresse',
        addressMain: 'Adresse principale',
        addressBilling: 'Adresse de facturation',
        addressShipping: 'Adresse de livraison',
        confirmRemove: 'Souhaitez-vous vraiment supprimer le contact?',
        errorLoad: 'Les adresses n`ont pas pu être chargées.',
        errorRemove: 'L`adresse n`a pas pu être supprimée.'
    },
    EditAddress: {
        title: 'Nouvelle adresse',
        errorTypeTitle: 'Veuillez définir un type d`adresse.',
        errorTypeText: 'L`adresse doit être une adresse de livraison et/ou de facturation.',
        errorCreate: 'L`adresse n`a pas pu être créée.',
        errorUpdate: 'L`adresse n`a pas pu être mise à jour.',
        shipping: 'livraisons',
        useForShippingNo: 'Ne pas utiliser comme adresse de livraison',
        useForShippingYes: 'Utiliser comme adresse de livraison',
        useForShippingDefault: 'Utiliser comme adresse de livraison',
        billing: 'Factures',
        useForBillingNo: 'Ne pas utiliser comme adresse de facturation',
        useForBillingYes: 'Utiliser comme adresse de facturation',
        useForBillingDefault: 'Utiliser comme adresse de facturation par défaut'
    },
    Projects: {
        title: 'Rapports',
        loading: 'Les rapports sont chargés',
        currentProjects: 'Rapports actuels',
        showAll: 'Afficher tous les rapports',
        noProjects: 'Aucun rapport',
        add: 'Nouveau rapport',
        projectNumber: 'Rapport n°.',
        projectName: 'ID du patient',
        projectType: 'Type de rapport',
        statusAll: 'Tous les rapports',
        statusOpen: 'Rapports ouverts',
        statusOrdered: 'Rapports commandés',
        errorNoName: 'Veuillez spécifier un nom de rapport.',
        errorCreate: 'Le rapport n`a pas pu être créé.',
        errorCouldNotLoad: 'Les rapports n`ont pas pu être chargés'
    },
    ProjectDetails: {
        title: 'Détails de la commande',
        loading: 'Le rapport est chargé',
        alertOrdered: 'Rapport commandé:',
        openOrder: 'Commande ouverte',
        alertReference: 'Ce projet est lié à un autre projet:',
        openProject: 'Rapport ouvert',
        toothSelection: 'Sélection des dents',
        noConstruction: 'Keine Konstruktion festgelegt!',
        editConstruction: 'Kontruktion bearbeiten',
        materialSelection: 'Materialauswahl',
        estimatedDelivery: 'Vorauss. Lieferdatum',
        missingMaterial: 'Materialauswahl fehlt',
        missingAttachments: 'Pièces jointes manquantes',
        addStl: 'STL hinzufügen',
        openCart: 'Vers le panier d`achat',
        emptyCart: 'Panier vide',
        shippingType: 'Mode d`expédition',
        construction: 'Konstruktion',
        stlUpload: 'STL Upload',
        attachments: 'Pièces jointes',
        addons: 'Produits supplémentaires',
        cart: 'Panier',
        addItem: 'Ajouter le produit',
        orderProject: 'Confirmer la commande',
        statusNotOrdered: 'Non commandé',
        statusOrdered: 'Commandes',
        errorNoProjectnum: 'Aucun numéro de rapport valide n`a été transféré',
        costs: 'Coûts du projet',
        removed: 'Supprimer le projet',
        removing: 'Le projet est supprimé',
        saved: 'Projet suavegardé',
        saving: 'Le projet est sauvé',
        orderSuccessful: 'Commande réussie'
    },
    Orders: {
        title: 'Commandes',
        loading: 'Les commandes sont chargées',
        currentOrders: 'Commandes en cours',
        openOrder: 'Commande ouverte',
        showAll: 'Afficher toutes les commandes',
        noOrders: 'Pas de commandes',
        orderNum: 'Commande N°',
        projectRef: 'Référence du projet',
        statusAll: 'Toutes les commandes',
        errorCouldNotLoad: 'Les commandes n`ont pas pu être chargées',
        statusNotOrdered: 'Non commandé',
        statusReceived: 'Réceptionné',
        statusCancelled: 'Annulé',
        statusReceivedDescr: 'L`ordre est vérifié',
        statusInProgress: 'En cours',
        statusInProgressDescr: 'Votre commande est en cours de traitement',
        statusInProduction: 'En production',
        statusInProductionDescr: 'La production a commencé',
        statusDelivered: 'Envoyé',
        statusDeliveredDescr: 'Votre commande a été expédiée'
    },
    Reports: {
        statusAll: 'Tous les rapports',
        statusReceived: 'Données reçues',
        statusReceivedDescr: 'La commande est examinée.',
        statusInProgress: 'En gestion',
        statusInProgressDescr: 'Vos données sont traitées.',
        statusInProduction: 'Modèle de rapport établi',
        statusInProductionDescr: 'Votre modèle de rapport est créé',
        statusOnHold: 'Contenu',
        statusCancelled: 'Annulé',
        statusCancelledDescr: 'Votre commande a été annulée',
        statusClosed: 'Rapport généré',
        statusCompleted: 'Rapport générét',
        statusCompletedDescr: 'Vous avez généré votre rapport',
        statusInvoicedCancelled: 'Teilberechnet / Storniert',
        statusPartlyDelivered: 'Teilgeliefert',
        statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
        statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
        statusDelivered: 'Rapport généré',
        statusDeliveredDescr: 'Votre rapport est complet',
        statusReadyForPickup: 'Prêt pour la collecte',
    },
    OrderDetails: {
        title: 'Détails de la commande',
        deliveryNote: 'Bordereau de livraison',
        loading: 'La commande est chargée',
        trackingNum: 'N° de suivi',
        manufacturingStatus: 'État de la production',
        trackingAndBilling: 'Suivi et facturation',
        creatingOrder: 'Création de l`ordre',
        orderProject: 'Confirmer la commande',
        placeOrder: 'Passer la commande',
        acceptTerms: 'J`ai lu les <a href="{termsUrl}" target="_blank">conditions générales</a> de vente et je les accepte.',
        errorNoOrderNum: 'Aucun numéro de commande valide n`a été transféré',
        errorCouldNotLoad: 'La commande n`a pas pu être chargée',
        priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
        priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
        files: 'Fichiers'
    },
    Messages: {
        title: 'Nouvelles',
        noMessages: 'Keine Nachrichten',
        errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
        writeSomething: 'Schreiben Sie was...',
        errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
    },
    Configurator: {
        selectIndication: 'Indikation wählen',
        changeMaterial: 'Material ändern',
        selectTooth: 'Bitte wählen Sie einen Zahn',
        showToothNumbers: 'Zahnnummern anzeigen',
        toothSelection: 'Zahnauswahl',
        setProductProps: 'Produkteigenschaften festlegen',
        selectProduct: 'Produkt wählen',
        fileXofY: 'Datei {x} von {y}',
        calcPrice: 'Preise werden berechnet',
        uploadStl: 'STL hochladen',
        stlCount: 'Einheitenanzahl der obigen STL',
        stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
        oneUnit: 'Eine Einheit',
        nUnits: '{n} Einheiten',
        removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Rechnungen',
        loading: 'Rechnungen werden geladen',
        invoiceNum: 'Rechnung Nr.',
        monthlyStatement: 'Monatsaufstellung',
        statusReceived: 'Eingegangen',
        statusOpen: 'Offen',
        statusHold: 'Gehalten',
        statusCancelled: 'Storniert',
        statusClosed: 'Geschlossen',
        statusPartlyPaid: 'Teilbezahlt',
        statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
        statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
        statusPaid: 'Bezahlt'
    },
    File: {
        name: 'Nom du fichier',
        hash: 'Hachis de fichiers',
        size: 'Taille du fichier',
        messageUpload: 'Veuillez cliquer pour charger ou déplacer le fichier sur la case',
        allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
        sendingData: 'Les données sont transmises',
        processingData: 'Les données sont traitées',
        errorUpload: 'Une erreur s`est produite. Malheureusement, le fichier n`a pas pu être téléchargé.',
        errorCouldNotList: 'Les fichiers n`ont pas pu être chargés.',
        errorCouldNotLoad: 'Le fichier n`a pas pu être chargé.',
        errorCouldNotDelete: 'Le dossier n`a pas pu être supprimé.'
    },
    Login: {
        username: 'E-Mail ou N° du client',
        password: 'Mot de passe',
        passwordOld: 'Ancien mot de passe',
        passwordNew: 'Nouveau mot de passe',
        passwordConfirm: 'Confirmer le nouveau mot de passe',
        passwordSaved: 'Mot de passe enregistré',
        login: 'Login',
        logout: 'Logout',
        enterPwd: 'Veuillez indiquer un mot de passe',
        invalidUserOrPwd: 'Nom d`utilisateur / mot de passe non valides',
        errorCouldNotUpdate: 'Le mot de passe n`a pas pu être enregistré.',
        errorPasswordNoMatch: 'Les mots de passe ne correspondent pas.',
        errorOldPassword: 'L`ancien mot de passe est erroné.',
        errorNoSession: 'Aucune session utilisateur trouvée. Veuillez vous connecter.'
    },
    Infothek: {
        title: 'Infothèque'
    }
};
